export default __webpack_public_path__ + "static/media/defaultImg.3afd9966.jpg";